import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Title from './Title';
// Icons
import SettingsIcon from '@mui/icons-material/Settings';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import GppGoodIcon from '@mui/icons-material/GppGood';
import OutboxIcon from '@mui/icons-material/Outbox';
import RunningWithErrorsIcon from '@mui/icons-material/RunningWithErrors';
import FlagIcon from '@mui/icons-material/Flag';
import EngineeringIcon from '@mui/icons-material/Engineering';
import VerifiedIcon from '@mui/icons-material/Verified';

// Styles
import { blue_pilu } from '../../../helpers/utils';
import { Link } from '@mui/material';
import { getFormattedMonth } from '../../../helpers/hours';

const useStyles = makeStyles({
	depositContext: {
		flex: 1,
	},
});

const measures = '35%';

const iconStyle = { color: blue_pilu, width: measures, height: measures };

const ICONS = {
	ICF: <SettingsIcon style={iconStyle} />,
	VAL: <CheckCircleOutlineIcon style={iconStyle} />,
	AUT: <GppGoodIcon style={iconStyle} />,
	REL: <OutboxIcon style={iconStyle} />,
	DLY: <RunningWithErrorsIcon style={iconStyle} />,
	NST: <FlagIcon style={iconStyle} />,
	IPR: <EngineeringIcon style={iconStyle} />,
	FIN: <VerifiedIcon style={iconStyle} />,
};

export default function Deposits({
	name = '',
	number = 0,
	icon = '',
	monthly = 10,
}) {
	const classes = useStyles();
	return (
		<div>
			<div
				style={{
					display: 'flex',
					flexDirection: 'row',
					justifyContent: 'space-between',
				}}
			>
				<div>
					<Title>{name}</Title>
					<Typography component='p' variant='h4'>
						{monthly}
					</Typography>
				</div>
				{ICONS[icon]}
			</div>

			<Typography
				style={{ margin: '10px 0' }}
				color='textSecondary'
				className={classes.depositContext}
			>
				Total global: {number}
			</Typography>
		</div>
	);
}
